// store/actionsToProblemsSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { API_BASE_URL } from "../config";

const initialState = {
  problemActions: [],
  currentProblemAction: null,
  status: "idle",
  error: null,
};

// Fetch all ActionsToProblems
export const fetchProblemActions = createAsyncThunk(
  "problemActions/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${API_BASE_URL}/api/ActionsToProblems/fetch/all`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch problem-action relations"
      );
    }
  }
);

// Create a new ActionToProblem
export const createProblemAction = createAsyncThunk(
  "problemActions/create",
  async (data, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${API_BASE_URL}/api/ActionsToProblems/create`,
        data,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to create problem-action relation"
      );
    }
  }
);

// Edit an existing ActionToProblem
export const editProblemAction = createAsyncThunk(
  "problemActions/edit",
  async (data, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.put(
        `${API_BASE_URL}/api/ActionsToProblems/edit`,
        data,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to edit problem-action relation"
      );
    }
  }
);

// Delete an ActionToProblem
export const deleteProblemAction = createAsyncThunk(
  "problemActions/delete",
  async (problemActionID, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      await axios.delete(
        `${API_BASE_URL}/api/ActionsToProblems/hardDelete/${problemActionID}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      return problemActionID;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to delete problem-action relation"
      );
    }
  }
);

const actionsToProblemsSlice = createSlice({
  name: "problemActions",
  initialState,
  reducers: {
    resetProblemActionForm(state) {
      state.status = "idle";
      state.error = null;
      state.currentProblemAction = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProblemActions.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchProblemActions.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.problemActions = action.payload;
      })
      .addCase(fetchProblemActions.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      .addCase(createProblemAction.fulfilled, (state, action) => {
        state.problemActions.push(action.payload);
      })

      .addCase(editProblemAction.fulfilled, (state, action) => {
        const index = state.problemActions.findIndex(
          (item) => item.problemActionID === action.payload.problemActionID
        );
        if (index !== -1) state.problemActions[index] = action.payload;
      })

      .addCase(deleteProblemAction.fulfilled, (state, action) => {
        state.problemActions = state.problemActions.filter(
          (item) => item.problemActionID !== action.payload
        );
      });
  },
});

export const { resetProblemActionForm } = actionsToProblemsSlice.actions;
export default actionsToProblemsSlice.reducer;
